import { Component, ChangeDetectionStrategy, ViewEncapsulation, input, output } from '@angular/core';

@Component({
  selector: 'tidy-sub-tabs',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./sub-tabs.component.scss'],
  template: `
    <div class="sub-tabs" role="tablist">
      @for (tab of tabs(); track tab.value) {
        <div class="sub-tab-item"
          role="tab"
          [attr.aria-selected]="activeTab() === tab.value"
          [class.active]="activeTab() === tab.value"
          (click)="tabChange.emit(tab.value)">
          @if (tab.icon) {
            <span class="sub-tab-icon" [style.-webkit-mask-image]="'url(' + tab.icon + ')'" [style.mask-image]="'url(' + tab.icon + ')'"></span>
          }
          {{ tab.label }}
        </div>
      }
    </div>
  `
})
export class SubTabsComponent {
  tabs = input.required<{ value: string; label: string; icon?: string }[]>();
  activeTab = input.required<string>();
  tabChange = output<string>();
}
